import { GET_LOCATION_DATA, GET_LOCATION_DATA_SUCCESS, GET_LOCATION_DATA_FAIL } from '../Type';

const INITIAL = {
  LocationData: null,
  get_location_data_loading: false,
  get_location_data_success: false
}

export default (state = INITIAL, action) => {
  switch (action.type) {
    case GET_LOCATION_DATA: {
      return {
        get_location_data_loading: true,
        get_location_data_success: false,
      }
    }
    case GET_LOCATION_DATA_FAIL: {
        return {
          LocationData: null,
          get_location_data_loading: false,
          get_location_data_success: false
        }
    }
    case GET_LOCATION_DATA_SUCCESS: {
      return {
        LocationData: action.data,
        get_location_data_loading: false,
        get_location_data_success: true
      }
    }

    default:
        return state;
  }
}